document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(".mega-menu__link");

  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", function () {
      // Use querySelector to find the closest featured image
      const featuredImage = link
        .closest("header-menu")
        .querySelector(".featured-image");
      const imageUrl = link.getAttribute("data-featured-image");

      console.log(imageUrl); // Debug: log the image URL

      if (imageUrl) {
        featuredImage.src = imageUrl; // Set the image source
        featuredImage.style.display = "block"; // Show the image
      }
    });

    link.addEventListener("mouseleave", function () {
      const featuredImage = link
        .closest("header-menu")
        .querySelector(".featured-image");
      featuredImage.style.display = "none"; // Hide the image when not hovering
    });
  });

 let items = document.querySelectorAll(".header__inline-menu details");

items.forEach(item => {
  const menuContent = item.querySelector(".mega-menu__content"); // Grab the mega menu content

  // Open the menu on mouseover of the title
  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
  });

  // Keep the menu open when hovering over the mega menu
  menuContent.addEventListener("mouseenter", () => {
    item.setAttribute("open", true); // Keep it open when hovering over the mega menu
  });

  // Close the menu when the mouse leaves the mega menu
  menuContent.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

});
